export enum PassportReqTypes {
  PP_RENEWAL = 1,
  EMIRATES_ID,
  BANK,
  IMMIGRATION,
  PERSONAL,
  OTHER,
}
